import createReactComponent from '../createReactComponent';
export default createReactComponent('tree-pine', 'TreePine', [["path",{"d":"M12 17h7l-4.5-4.5h3l-3.75-4.25L12 3l-1.75 5.25L6.5 12.5h3L5 17zm0 0v4","key":"svg-0"}]]);